import { AlertCircle, CheckCircle2 } from "lucide-react"

import { useToast } from "../../hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "./toast"

const TOAST_DURATION = {
  default: 5000,
  success: 4000,
  destructive: 8000,
}

function ToastStatusIcon({ variant }) {
  if (variant === "success") {
    return <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-green-600 dark:text-green-400" aria-hidden="true" />
  }
  if (variant === "destructive") {
    return <AlertCircle className="mt-0.5 h-4 w-4 shrink-0 text-red-600 dark:text-red-400" aria-hidden="true" />
  }
  return null
}

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        const resolvedVariant = variant || "default"
        return (
          <Toast
            key={id}
            variant={resolvedVariant}
            duration={TOAST_DURATION[resolvedVariant] || TOAST_DURATION.default}
            {...props}
          >
            <div className="flex gap-2">
              <ToastStatusIcon variant={resolvedVariant} />
              <div className="grid min-w-0 flex-1 gap-1">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}